import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Truck, X } from "lucide-react";

const STORAGE_KEY = "bsc_free_shipping_banner_dismissed_v1";

/**
 * Slim, sticky-top promo strip announcing free shipping.
 *
 * Auto-hides when:
 *   - User dismissed it (remembered for this browser session)
 *   - Backend says the free-shipping threshold is > 0 (i.e., promo is off)
 *   - /api/shop-status hasn't loaded yet (no flash of stale content)
 */
const FreeShippingBanner = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem(STORAGE_KEY) === "1") return;
        let alive = true;
        api.get("/shop-status")
            .then((r) => {
                if (!alive) return;
                const t = r.data?.shipping?.free_threshold_usd;
                // 0 means free on every order — show banner
                if (typeof t === "number" && t === 0) {
                    setShow(true);
                }
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    if (!show) return null;

    const dismiss = () => {
        sessionStorage.setItem(STORAGE_KEY, "1");
        setShow(false);
    };

    return (
        <div
            data-testid="free-shipping-banner"
            className="relative bg-[#004466] text-white text-center py-2 px-4 z-50"
        >
            <div className="flex items-center justify-center gap-2 font-chivo text-[11px] tracking-[0.18em] uppercase">
                <Truck className="w-3.5 h-3.5 flex-shrink-0" />
                <span>
                    Free Shipping{" "}
                    <span className="hidden sm:inline">
                        on every order
                    </span>
                    <span className="sm:hidden">on all orders</span>{" "}
                    · No code needed
                </span>
            </div>
            <button
                onClick={dismiss}
                data-testid="free-shipping-banner-dismiss"
                aria-label="Dismiss free shipping banner"
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-white/70 hover:text-white transition-colors"
            >
                <X className="w-3.5 h-3.5" />
            </button>
        </div>
    );
};

export default FreeShippingBanner;
